function VideoModal(triggerEl) {
    this.triggerEl = triggerEl;
    this.modal = null;
    this.isInitialized = false;
    this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;
    this.previousActiveElement = null;

    this.addEventListeners();
}

VideoModal.prototype = {
    addEventListeners: function() {
        this.triggerEl.addEventListener('click', this.handleClick.bind(this));
    },

    handleClick: function(e) {
        e.preventDefault();

        if (!this.isInitialized) {
            this.initializeModal();
            this.isInitialized = true;
        }

        const videoUrl = this.triggerEl.getAttribute('data-video-url');
        const videoId = this.extractVideoId(videoUrl);
        const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

        const iframe = this.modal.querySelector('iframe');
        iframe.src = embedUrl;
        iframe.setAttribute('tabindex', '0');
        iframe.setAttribute('title', 'YouTube video player');

        this.modal.classList.add('is-active');
        document.body.classList.add('has-modal-open');

        // Bewaar het element dat focus had voor we de modal openden
        this.previousActiveElement = document.activeElement;

        // Focus beheren
        this.setupFocusTrap();
        this.firstFocusableElement.focus();
    },

    extractVideoId: function(url) {
        const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    },

    initializeModal: function() {
        this.modal = document.createElement('div');
        this.modal.className = 'video-modal';
        this.modal.setAttribute('role', 'dialog');
        this.modal.setAttribute('aria-labelledby', 'video-modal-title');
        this.modal.setAttribute('aria-modal', 'true');
        this.modal.setAttribute('tabindex', '-1');

        this.modal.innerHTML = `
            <div class="video-modal__overlay" tabindex="-1"></div>
            <div class="video-modal__content" role="document">
                <button class="video-modal__close" aria-label="Sluit video">
                    <span class="video-modal__close-icon"></span>
                </button>
                <div class="video-modal__video-container">
                    <iframe
                        width="560"
                        height="315"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        title="Video player"
                        tabindex="0"
                    ></iframe>
                </div>
            </div>
        `;

        document.body.appendChild(this.modal);

        // Event listeners voor het sluiten van de modal
        const closeButton = this.modal.querySelector('.video-modal__close');
        const overlay = this.modal.querySelector('.video-modal__overlay');

        closeButton.addEventListener('click', this.closeModal.bind(this));
        overlay.addEventListener('click', this.closeModal.bind(this));
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
    },

    setupFocusTrap: function() {
        const focusableElements = this.modal.querySelectorAll(this.focusableElements);
        this.firstFocusableElement = focusableElements[0];
        this.lastFocusableElement = focusableElements[focusableElements.length - 1];

        // Voorkom dat elementen buiten de modal focus kunnen krijgen
        const allFocusableElements = document.querySelectorAll(this.focusableElements);
        allFocusableElements.forEach(el => {
            if (!this.modal.contains(el)) {
                el.setAttribute('tabindex', '-1');
            }
        });

        this.modal.addEventListener('keydown', this.handleFocusTrap.bind(this));
    },

    handleFocusTrap: function(e) {
        if (e.key !== 'Tab') return;

        const iframe = this.modal.querySelector('iframe');
        const isInIframe = document.activeElement === iframe;

        // Als we in de iframe zijn, laten we de browser de focus beheren
        if (isInIframe) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableElement) {
                e.preventDefault();
                this.lastFocusableElement.focus();
            }
        } else {
            if (document.activeElement === this.lastFocusableElement) {
                e.preventDefault();
                this.firstFocusableElement.focus();
            }
        }
    },

    closeModal: function() {
        this.modal.classList.remove('is-active');
        document.body.classList.remove('has-modal-open');
        const iframe = this.modal.querySelector('iframe');
        iframe.src = '';
        iframe.removeAttribute('tabindex');

        // Herstel tabindex van alle elementen buiten de modal
        const allFocusableElements = document.querySelectorAll(this.focusableElements);
        allFocusableElements.forEach(el => {
            if (!this.modal.contains(el)) {
                el.removeAttribute('tabindex');
            }
        });

        // Focus terug naar het vorige element
        if (this.previousActiveElement) {
            this.previousActiveElement.focus();
        } else {
            this.triggerEl.focus();
        }
    },

    handleKeyDown: function(e) {
        if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
            this.closeModal();
        }
    }
};

(function() {
    const videoModalTriggerEls = document.querySelectorAll('.jsVideoModalTrigger');
    videoModalTriggerEls.forEach(el => new VideoModal(el));
})();
